import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { ScSectionTitle, ScSectionTitleProps } from './styled';

export const SectionTitle: FC<PropsWithChildren<ScSectionTitleProps>> = ({
  children,
  ...props
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <ScSectionTitle className={language.toLowerCase()} {...props}>
      {children}
    </ScSectionTitle>
  );
};
